import { enumToOptions } from '@app/shared/helpers';
import { Denomination } from '@app/shared/models/contracts/enums/shared-enums';

export const DENOMINATION_OPTIONS = enumToOptions(Denomination);
